import { createApp } from 'vue'
import VocabReviewSession from '../components/VocabReviewSession.vue'

export function mountVocabReview() {
  const el = document.getElementById('vocab-review-app')
  if (!el) return

  const app = createApp(VocabReviewSession, {
    backUrl: el.dataset.backUrl,
  })
  app.mount(el)
}
